import React from 'react';

import { PrismicRichText } from 'types/prismicRichtext';
import { PrismicLink } from 'types/prismicLink';
import { linkResolver } from 'utils/linkResolver';

import { Iframe } from 'components/iframe/Iframe';
import { asText } from 'components/rich-text/RichText';

interface IIframeContainer {
  title: PrismicRichText;
  link: PrismicLink;
  width?: number;
  height?: number;
}

export const IframeContainer = ({
  title,
  link,
  width,
  height,
}: IIframeContainer) => {
  return (
    <Iframe
      title={title ? asText(title) : undefined}
      src={linkResolver(link)}
      width={width}
      height={height}
    />
  );
};
